import React from 'react';
import './AnimatedLogo.css';
import brush from '../assets/brush.png';
import drop from '../assets/drop.png';

const AnimatedLogo = () => {
  return (
    <div className="logo-container">
      <img src={brush} className="brush" alt="Brush" />
      <img src={drop} className="drop" alt="Drop" />
    </div>
  );
};

export default AnimatedLogo;